
export async function instantiate(imports={}, runInitializer=true) {
    const cachedJsObjects = new WeakMap();
    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_Li9za2lrby5tanM_c2tpa29BcGk = imports['./skiko.mjs'].skikoApi;
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];

    const wasmJsTag = WebAssembly.JSTag;
    const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

    const js_code = {
        'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
        'kotlin.wasm.internal.jsThrow' : typeof wasmJsTag === 'undefined' || wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
        'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.JsString_$external_class_get' : () => JsString,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
        'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.Event_$external_class_get' : () => Event,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
        'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
        'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
        'org.w3c.dom.ShadowRootInit' : (mode) => { return { mode }; },
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => { return { passive, once, capture }; },
        'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
        'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
        'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
        'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
        'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
        'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
        'org.w3c.dom.Node_$external_class_get' : () => Node,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
        'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.Touch_$external_class_instanceof' : (x) => x instanceof Touch,
        'org.w3c.dom.Touch_$external_class_get' : () => Touch,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
        'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
        'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
        'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
        'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
        'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
        'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
        'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
        'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
        'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
        'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
        'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
            container.style.setProperty("--compose-internal-web-backing-input-left", left);
            container.style.setProperty("--compose-internal-web-backing-input-top", top);
            container.style.setProperty("--compose-internal-web-backing-input-width", width);
            container.style.setProperty("--compose-internal-web-backing-input-height", height)
         },
        'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
        'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
        'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
        'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
        'androidx.compose.ui.platform.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
        'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
        'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
        'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
        'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
        'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
                window.navigator.clipboard && 
                window.navigator.clipboard.write && 
                window.navigator.clipboard.read && 
                typeof(ClipboardItem) !== 'undefined'
                )
            ,
        'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
        'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
                var roleValue = "";
                switch (ariaRoleId) {
                    case 0: // Role.Button
                        roleValue = "button";
                        break;
                    case 1: // Role.Checkbox
                        roleValue = "checkbox";
                        break;
                    case 2: // Role.Switch
                        roleValue = "switch";
                        break;
                    case 3: // Role.RadioButton
                        roleValue = "radio";
                        break;
                    case 4: // Role.Tab
                        roleValue = "tab";
                        break;
                    case 5: // Role.Image
                        roleValue = "img";
                        break;
                    case 6: // Role.DropdownList
                        roleValue = "menu";
                        break;
                    case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                        roleValue = "heading";
                        break;
                    case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                        roleValue = "textbox";
                        break;
                    case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                        roleValue = "list";
                        break;
                    case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                        roleValue = "grid";
                        break;
                    default:
                        break;
                }
                if (roleValue.length > 0) { 
                    element.setAttribute("role", roleValue);
                } else {
                    element.removeAttribute("role");
                }
             },
        'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
               element.style.left = "" + left + "px";
               element.style.top = "" + top + "px";
               element.style.width = "" + width + "px";
               element.style.height = "" + height + "px";
             },
        'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
        'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
        'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
        'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'com.metaldetectoraudioapp.app.inference.consoleLog' : (msg) => console.log(msg),
        'com.metaldetectoraudioapp.app.inference.consoleWarn' : (msg) => console.warn(msg),
        'com.metaldetectoraudioapp.app.inference.consoleError' : (msg) => console.error(msg),
        'com.metaldetectoraudioapp.app.recording.formatLocalTimestampJs' : (epochMillis) => 
            (function () {
                var d = new Date(epochMillis);
                function p(n, w) { n = String(n); while (n.length < w) n = '0' + n; return n; }
                return p(d.getFullYear(), 4) + p(d.getMonth() + 1, 2) + p(d.getDate(), 2) + '_' +
                       p(d.getHours(), 2) + p(d.getMinutes(), 2) + p(d.getSeconds(), 2) + '_' +
                       p(d.getMilliseconds(), 3);
            })()
            ,
        'com.metaldetectoraudioapp.app.util.jsDateNow' : () => Date.now(),
        'com.metaldetectoraudioapp.web.audio.getUserMediaStrictlyVerified' : (streamGlobalName, onStream, onDeviceVerified, onDeviceRejected, onError) => { 
                function stopStream(stream) {
                    stream.getTracks().forEach(function(t) { t.stop(); });
                    if (window[streamGlobalName] === stream) window[streamGlobalName] = null;
                }
                function store(stream) {
                    var requestedId = window.__micDeviceId || '';
                    var tracks = stream.getAudioTracks();
                    var actualId = '';
                    if (tracks.length > 0 && tracks[0].getSettings) {
                        actualId = tracks[0].getSettings().deviceId || '';
                    }
                    if (requestedId && (!actualId || actualId !== requestedId)) {
                        stopStream(stream);
                        onDeviceRejected(requestedId, actualId);
                        onError(
                            actualId
                                ? 'Selected microphone could not be verified. Browser returned a different input.'
                                : 'Selected microphone could not be verified. Browser did not report the captured input.'
                        );
                        return;
                    }
                    window[streamGlobalName] = stream;
                    onDeviceVerified(requestedId, actualId);
                    onStream();
                }
                function attempt(constraints) {
                    navigator.mediaDevices.getUserMedia({ audio: constraints, video: false })
                        .then(function(stream) { store(stream); })
                        .catch(function(e) {
                            var name = (e && e.name) ? e.name : '';
                            var msg = (e && e.message) ? e.message : String(e);
                            onError(name ? (msg + ' (' + name + ')') : msg);
                        });
                }
                function baseConstraints() {
                    return {
                        echoCancellation: false,
                        noiseSuppression: false,
                        autoGainControl: false,
                        channelCount: 1
                    };
                }
                if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                    onError('This browser does not support microphone capture.');
                } else {
                    var first = baseConstraints();
                    if (window.__micDeviceId) first.deviceId = { exact: window.__micDeviceId };
                    attempt(first);
                }
             },
        'com.metaldetectoraudioapp.web.audio.__convertKotlinClosureToJsClosure_((String,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((String,String)->Unit)'](f, p0, p1)),
        'com.metaldetectoraudioapp.web.audio.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
        'com.metaldetectoraudioapp.web.audio.selectedMicDeviceId' : () => window.__micDeviceId || '',
        'com.metaldetectoraudioapp.web.audio.setSelectedMicDeviceId' : (deviceId) => window.__micDeviceId = deviceId,
        'com.metaldetectoraudioapp.web.audio.selectedOutputDeviceId' : () => window.__mdInfSinkId || '',
        'com.metaldetectoraudioapp.web.audio.selectedPreviewOutputDeviceId' : () => window.__mdPreviewSinkId || '',
        'com.metaldetectoraudioapp.web.audio.setSelectedPreviewOutputDeviceId' : (deviceId) => window.__mdPreviewSinkId = deviceId,
        'com.metaldetectoraudioapp.web.audio.outputSinkSupportedJs' : () => (typeof AudioContext !== 'undefined' && 'setSinkId' in AudioContext.prototype) ? 1 : 0,
        'com.metaldetectoraudioapp.web.audio.mediaElementSinkSupportedJs' : () => (typeof HTMLMediaElement !== 'undefined' && 'setSinkId' in HTMLMediaElement.prototype) ? 1 : 0,
        'com.metaldetectoraudioapp.web.audio.deviceIdAt' : (global, i) => window[global][i].deviceId,
        'com.metaldetectoraudioapp.web.audio.labelAt' : (global, i) => window[global][i].label,
        'com.metaldetectoraudioapp.web.audio.requestMicPermission' : (onResult) => { 
                if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { onResult(0); return; }
                navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(function(stream) {
                    stream.getTracks().forEach(function(t) { t.stop(); });
                    onResult(1);
                }).catch(function(e) { onResult(0); });
             },
        'com.metaldetectoraudioapp.web.audio.__convertKotlinClosureToJsClosure_((Int)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Int)->Unit)'](f, p0)),
        'com.metaldetectoraudioapp.web.audio.enumerateAudioDevicesToGlobals' : (useActiveStream, onSuccess, onError) => { 
                if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) { onError(); return; }
                function enumerate(after) {
                    navigator.mediaDevices.enumerateDevices().then(function(devices) {
                        window.__micDevices = devices
                            .filter(function(d) { return d.kind === 'audioinput' && d.deviceId !== 'default'; })
                            .map(function(d, idx) {
                                return { deviceId: d.deviceId, label: d.label || ('Microphone ' + (idx + 1)) };
                            });
                        window.__outDevices = devices
                            .filter(function(d) { return d.kind === 'audiooutput' && d.deviceId !== 'default'; })
                            .map(function(d, idx) {
                                return { deviceId: d.deviceId, label: d.label || ('Output ' + (idx + 1)) };
                            });
                        if (after) after();
                        onSuccess(window.__micDevices.length, window.__outDevices.length);
                    }).catch(function(e) { if (after) after(); onError(); });
                }
                // Best-effort: enumerate while a capture stream is live (see listAudioDevices). If a capture
                // is already running we benefit from it directly; otherwise, when explicitly requested, open
                // a brief default stream across the enumerate call and stop it. Never disturb active capture.
                var activeStream = window.__recStream || window.__mdInfStream;
                if (activeStream || useActiveStream !== 1 || !navigator.mediaDevices.getUserMedia) {
                    enumerate(null);
                } else {
                    navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(function(stream) {
                        enumerate(function() { stream.getTracks().forEach(function(t) { t.stop(); }); });
                    }).catch(function() { enumerate(null); });
                }
             },
        'com.metaldetectoraudioapp.web.audio.__convertKotlinClosureToJsClosure_((Int,Int)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Int,Int)->Unit)'](f, p0, p1)),
        'com.metaldetectoraudioapp.web.audio.addDeviceChangeListener' : (onChange) => { 
                if (navigator.mediaDevices && navigator.mediaDevices.addEventListener) {
                    navigator.mediaDevices.addEventListener('devicechange', function() { onChange(); });
                }
             },
        'com.metaldetectoraudioapp.web.audio.selectAudioOutputSupportedJs' : () => (navigator.mediaDevices && typeof navigator.mediaDevices.selectAudioOutput === 'function') ? 1 : 0,
        'com.metaldetectoraudioapp.web.audio.selectPlaybackOutputDeviceJs' : (deviceId, onSelected, onLabel) => { 
                if (navigator.mediaDevices && navigator.mediaDevices.selectAudioOutput) {
                    var opts = deviceId ? { deviceId: deviceId } : undefined;
                    navigator.mediaDevices.selectAudioOutput(opts)
                        .then(function(device) { onSelected(device.deviceId); onLabel(device.label || ''); })
                        .catch(function() { /* user cancelled or permission denied — no-op */ });
                } else {
                    onSelected(deviceId);
                    onLabel('');
                }
             },
        'com.metaldetectoraudioapp.web.audio.playAudioElement' : (url, playbackDeviceId, onEnded) => { 
                if (window.__mdAudioEl) { window.__mdAudioEl.pause(); }
                var audio = new Audio(url);
                window.__mdAudioEl = audio;
                audio.onended = function() { onEnded(); };
                audio.onerror = function() { onEnded(); };
                var startPlayback = function() {
                    audio.play().catch(function() { onEnded(); });
                };
                if (playbackDeviceId && typeof audio.setSinkId === 'function') {
                    audio.setSinkId(playbackDeviceId).then(startPlayback).catch(startPlayback);
                } else {
                    startPlayback();
                }
             },
        'com.metaldetectoraudioapp.web.audio.stopAudioElement' : () => { 
                if (window.__mdAudioEl) {
                    window.__mdAudioEl.pause();
                    window.__mdAudioEl = null;
                }
             },
        'com.metaldetectoraudioapp.web.audio.readGlobalInfBufAt' : (i) => window.__mdInfBuf[i],
        'com.metaldetectoraudioapp.web.audio.buildInfCaptureGraph' : (onChunk) => { 
                var stream = window.__mdInfStream;
                var ctx = new (window.AudioContext || window.webkitAudioContext)();
                window.__mdInfCtx = ctx;
                // iOS Safari starts the context suspended; resume it within this user gesture.
                if (ctx.state === 'suspended' && ctx.resume) ctx.resume();
                var src = ctx.createMediaStreamSource(stream);
        
                // Speaker pass-through ("monitor") branch: src -> monitorGain -> destination.
                // Gain defaults to 0 (silent) so it never feeds back unless explicitly enabled.
                // Kept separate from the silent inference sink below. See WebPassthroughMonitor.
                var monitorGain = ctx.createGain();
                monitorGain.gain.value = window.__mdInfPassthroughOn ? 1 : 0;
                window.__mdInfMonitorGain = monitorGain;
                src.connect(monitorGain);
                monitorGain.connect(ctx.destination);
                if (window.__mdInfSinkId && ctx.setSinkId) {
                    ctx.setSinkId(window.__mdInfSinkId).catch(function() {});
                }
        
                function sendChunk(channelData) {
                    window.__mdInfBuf = channelData;
                    onChunk(Math.round(ctx.sampleRate), channelData.length);
                }
        
                if (ctx.audioWorklet) {
                    ctx.audioWorklet.addModule('/app/mic-worklet.js').then(function() {
                        var node = new AudioWorkletNode(ctx, 'mic-processor');
                        var silentGain = ctx.createGain();
                        silentGain.gain.value = 0;
                        window.__mdInfNode = node;
                        window.__mdInfSilentGain = silentGain;
                        node.port.onmessage = function(e) { sendChunk(e.data); };
                        src.connect(node);
                        node.connect(silentGain);
                        silentGain.connect(ctx.destination);
                    }).catch(function() { workletFallback(ctx, src, sendChunk); });
                } else { workletFallback(ctx, src, sendChunk); }
        
                function workletFallback(ctx, src, sendChunk) {
                    var proc = ctx.createScriptProcessor(4096, 1, 1);
                    window.__mdInfProc = proc;
                    proc.onaudioprocess = function(e) { sendChunk(e.inputBuffer.getChannelData(0)); };
                    src.connect(proc);
                    proc.connect(ctx.destination);
                }
             },
        'com.metaldetectoraudioapp.web.audio.stopInfMicJs' : () => { 
                if (window.__mdInfNode)   { window.__mdInfNode.disconnect();   window.__mdInfNode = null; }
                if (window.__mdInfMonitorGain) { window.__mdInfMonitorGain.disconnect(); window.__mdInfMonitorGain = null; }
                if (window.__mdInfSilentGain) { window.__mdInfSilentGain.disconnect(); window.__mdInfSilentGain = null; }
                if (window.__mdInfProc)   { window.__mdInfProc.disconnect();   window.__mdInfProc = null; }
                if (window.__mdInfStream) { window.__mdInfStream.getTracks().forEach(function(t) { t.stop(); }); window.__mdInfStream = null; }
                if (window.__mdInfCtx)    { window.__mdInfCtx.close();         window.__mdInfCtx = null; }
                window.__mdInfBuf = null;
             },
        'com.metaldetectoraudioapp.web.audio.setPassthroughEnabledJs' : (enabled) => { 
                window.__mdInfPassthroughOn = (enabled === 1);
                if (window.__mdInfMonitorGain) {
                    window.__mdInfMonitorGain.gain.value = (enabled === 1) ? 1 : 0;
                }
             },
        'com.metaldetectoraudioapp.web.audio.setOutputSinkJs' : (deviceId) => { 
                window.__mdInfSinkId = deviceId;
                var ctx = window.__mdInfCtx;
                if (ctx && ctx.setSinkId) {
                    ctx.setSinkId(deviceId || '').catch(function() {});
                }
             },
        'com.metaldetectoraudioapp.web.audio.chooseOutputSinkJs' : (deviceId, onSelected) => { 
                function applySelectedSink(selectedId) {
                    window.__mdInfSinkId = selectedId;
                    var ctx = window.__mdInfCtx;
                    if (ctx && ctx.setSinkId) {
                        ctx.setSinkId(selectedId).then(function() {
                            onSelected(selectedId);
                        }).catch(function() {});
                    } else {
                        onSelected(selectedId);
                    }
                }
        
                if (deviceId && navigator.mediaDevices && navigator.mediaDevices.selectAudioOutput) {
                    navigator.mediaDevices.selectAudioOutput({ deviceId: deviceId })
                        .then(function(device) { applySelectedSink(device.deviceId); })
                        .catch(function() {});
                } else {
                    applySelectedSink(deviceId);
                }
             },
        'com.metaldetectoraudioapp.web.inference.readFetchGlobalBufByte' : (i) => window.__fetchBuf[i] << 24 >> 24,
        'com.metaldetectoraudioapp.web.inference.fetchTextJs' : (url, onSuccess, onError) => { 
                fetch(url).then(function(r) {
                    if (!r.ok) { onError('HTTP ' + r.status); return Promise.reject(); }
                    return r.text();
                }).then(function(t) { onSuccess(t); }).catch(function(e) { onError(String(e)); });
             },
        'com.metaldetectoraudioapp.web.inference.fetchBytesToGlobal' : (url, onSuccess, onError) => { 
                fetch(url).then(function(r) {
                    if (!r.ok) { onError('HTTP ' + r.status); return Promise.reject(); }
                    return r.arrayBuffer();
                }).then(function(ab) {
                    window.__fetchBuf = new Int8Array(ab);
                    onSuccess(window.__fetchBuf.length);
                }).catch(function(e) { onError(String(e)); });
             },
        'com.metaldetectoraudioapp.web.inference.initGlobalFloatBuf' : (size) => window.__ktFloatBuf = new Float32Array(size),
        'com.metaldetectoraudioapp.web.inference.setGlobalFloatAt' : (i, v) => window.__ktFloatBuf[i] = v,
        'com.metaldetectoraudioapp.web.inference.createOrtSessionFromGlobal' : (byteCount) => 
            (function() {
                var src = window.__ktWriteBuf;
                var arr = new Uint8Array(byteCount);
                for (var i = 0; i < byteCount; i++) arr[i] = src[i];
                return ort.InferenceSession.create(arr.buffer, {
                    executionProviders: ['wasm'],
                    intraOpNumThreads: 1
                });
            })()
        ,
        'com.metaldetectoraudioapp.web.inference.runOnnxInference' : (session, numFrames, numMels, loudness) => 
            (function() {
                var flat = window.__ktFloatBuf;
                var outputName = session.outputNames[0];
                var spectrogram = new ort.Tensor('float32', flat, [1, numFrames, numMels, 1]);
                var loudnessTensor = new ort.Tensor('float32', new Float32Array([loudness]), [1, 1]);
                var feeds = {};
                // Two-input model: match the loudness input by name; everything else is the spectrogram.
                for (var i = 0; i < session.inputNames.length; i++) {
                    var name = session.inputNames[i];
                    feeds[name] = (name.indexOf('loud') >= 0) ? loudnessTensor : spectrogram;
                }
                return session.run(feeds).then(function(output) {
                    return output[outputName].data;
                });
            })()
        ,
        'com.metaldetectoraudioapp.web.inference.getOutputFloat' : (arr, index) => arr[index],
        'com.metaldetectoraudioapp.web.platform.initWriteBuf' : (size) => window.__ktWriteBuf = new Uint8Array(size),
        'com.metaldetectoraudioapp.web.platform.setWriteBufByte' : (i, v) => window.__ktWriteBuf[i] = v & 0xFF,
        'com.metaldetectoraudioapp.web.platform.createBlobUrlFromGlobal' : (count, mimeType) => URL.createObjectURL(new Blob([window.__ktWriteBuf.slice(0, count)], { type: mimeType })),
        'com.metaldetectoraudioapp.web.platform.revokeObjectUrl' : (url) => URL.revokeObjectURL(url),
        'com.metaldetectoraudioapp.web.platform.jsErrorMessage' : (reason) => String(reason && reason.message ? reason.message : reason),
        'com.metaldetectoraudioapp.web.platform.promiseThen' : (promise, onFulfilled, onRejected) => promise.then(onFulfilled, onRejected),
        'com.metaldetectoraudioapp.web.platform.__convertKotlinClosureToJsClosure_((Js?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Unit)'](f, p0)),
        'com.metaldetectoraudioapp.web.platform.triggerDownload' : (url, fileName) => { 
                var a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
             },
        'com.metaldetectoraudioapp.web.platform.readFileBufByte' : (i) => window.__fileBuf[i] << 24 >> 24,
        'com.metaldetectoraudioapp.web.platform.openFilePicker' : (accept, onCancelled, onLoaded) => { 
                var input = document.createElement('input');
                input.type = 'file';
                if (accept) input.accept = accept;
                input.style.display = 'none';
                document.body.appendChild(input);
                input.onchange = function() {
                    var file = input.files && input.files[0];
                    document.body.removeChild(input);
                    if (!file) { onLoaded(-1); return; }
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        window.__fileBuf = new Int8Array(e.target.result);
                        onLoaded(window.__fileBuf.length);
                    };
                    reader.onerror = function() { onLoaded(-1); };
                    reader.readAsArrayBuffer(file);
                };
                input.click();
             },
        'com.metaldetectoraudioapp.web.platform.requestCurrentLocation' : (onCompleted) => { 
                if (!navigator.geolocation) {
                    onCompleted(5, 0, 0, 'Geolocation is not supported by this browser');
                } else {
                    navigator.geolocation.getCurrentPosition(
                        function(position) {
                            onCompleted(1, position.coords.latitude, position.coords.longitude, '');
                        },
                        function(error) {
                            var status = error.code === 1 ? 2 : (error.code === 3 ? 3 : 4);
                            onCompleted(status, 0, 0, error.message || '');
                        },
                        {
                            enableHighAccuracy: true,
                            maximumAge: 0,
                            timeout: 15000
                        }
                    );
                }
             },
        'com.metaldetectoraudioapp.web.platform.__convertKotlinClosureToJsClosure_((Int,Double,Double,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3) => wasmExports['__callFunction_((Int,Double,Double,String)->Unit)'](f, p0, p1, p2, p3)),
        'com.metaldetectoraudioapp.web.platform.readCapturedPhotoByte' : (index) => window.__capturedPhotoBytes[index] << 24 >> 24,
        'com.metaldetectoraudioapp.web.platform.clearCapturedPhotoBytes' : () => window.__capturedPhotoBytes = null,
        'com.metaldetectoraudioapp.web.platform.openPhotoPicker' : (useCamera, onCompleted) => { 
                var input = document.createElement('input');
                input.type = 'file';
                input.accept = 'image/*';
                if (useCamera) input.capture = 'environment';
                input.style.display = 'none';
                document.body.appendChild(input);
        
                var settled = false;
                function finish(status, count, message) {
                    if (settled) return;
                    settled = true;
                    window.removeEventListener('focus', handleWindowFocus);
                    if (input.parentNode) input.parentNode.removeChild(input);
                    onCompleted(status, count, message || '');
                }
        
                function handleWindowFocus() {
                    // Older browsers do not fire `cancel`; wait for a possible `change` event first.
                    window.setTimeout(function() {
                        if (!settled && (!input.files || input.files.length === 0)) finish(0, 0, '');
                    }, 700);
                }
        
                input.oncancel = function() { finish(0, 0, ''); };
                input.onchange = function() {
                    var file = input.files && input.files[0];
                    if (!file) { finish(0, 0, ''); return; }
        
                    var objectUrl = URL.createObjectURL(file);
                    var image = new Image();
                    image.onload = function() {
                        try {
                            var maximumLongEdge = 1600;
                            var sourceWidth = image.naturalWidth || image.width;
                            var sourceHeight = image.naturalHeight || image.height;
                            if (!sourceWidth || !sourceHeight) throw new Error('The selected image has no dimensions');
        
                            var scale = Math.min(1, maximumLongEdge / Math.max(sourceWidth, sourceHeight));
                            var outputWidth = Math.max(1, Math.round(sourceWidth * scale));
                            var outputHeight = Math.max(1, Math.round(sourceHeight * scale));
                            var canvas = document.createElement('canvas');
                            canvas.width = outputWidth;
                            canvas.height = outputHeight;
                            var context = canvas.getContext('2d');
                            if (!context) throw new Error('Image conversion is unavailable');
                            context.drawImage(image, 0, 0, outputWidth, outputHeight);
        
                            canvas.toBlob(function(blob) {
                                URL.revokeObjectURL(objectUrl);
                                if (!blob) { finish(-1, 0, 'Unable to encode the selected image'); return; }
                                blob.arrayBuffer().then(function(buffer) {
                                    window.__capturedPhotoBytes = new Int8Array(buffer);
                                    finish(1, window.__capturedPhotoBytes.length, '');
                                }).catch(function(error) {
                                    finish(-1, 0, error && error.message ? error.message : String(error));
                                });
                            }, 'image/jpeg', 0.9);
                        } catch (error) {
                            URL.revokeObjectURL(objectUrl);
                            finish(-1, 0, error && error.message ? error.message : String(error));
                        }
                    };
                    image.onerror = function() {
                        URL.revokeObjectURL(objectUrl);
                        finish(-1, 0, 'The selected file could not be decoded as an image');
                    };
                    image.src = objectUrl;
                };
        
                window.addEventListener('focus', handleWindowFocus);
                input.click();
             },
        'com.metaldetectoraudioapp.web.platform.__convertKotlinClosureToJsClosure_((Int,Int,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((Int,Int,String)->Unit)'](f, p0, p1, p2)),
        'com.metaldetectoraudioapp.web.storage.readTmpByte' : (index) => (window.__idbTmpBytes[index] << 24 >> 24),
        'com.metaldetectoraudioapp.web.storage.clearTmpBytes' : () => window.__idbTmpBytes = null,
        'com.metaldetectoraudioapp.web.storage.idbGetString' : (store, key, callback) => { 
                var req = indexedDB.open('metaldetector_dataset', 1);
                req.onupgradeneeded = function(e) {
                    var db = e.target.result;
                    ['meta','audio','images'].forEach(function(s) {
                        if (!db.objectStoreNames.contains(s)) db.createObjectStore(s);
                    });
                };
                req.onsuccess = function(e) {
                    var db = e.target.result, tx = db.transaction(store, 'readonly');
                    var r = tx.objectStore(store).get(key);
                    r.onsuccess = function() {
                        callback(r.result !== undefined ? String(r.result) : null);
                    };
                    r.onerror = function() { callback(null); };
                };
                req.onerror = function() { callback(null); };
             },
        'com.metaldetectoraudioapp.web.storage.__convertKotlinClosureToJsClosure_((String?)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String?)->Unit)'](f, p0)),
        'com.metaldetectoraudioapp.web.storage.idbPutString' : (store, key, value, callback) => { 
                var req = indexedDB.open('metaldetector_dataset', 1);
                req.onupgradeneeded = function(e) {
                    var db = e.target.result;
                    ['meta','audio','images'].forEach(function(s) {
                        if (!db.objectStoreNames.contains(s)) db.createObjectStore(s);
                    });
                };
                req.onsuccess = function(e) {
                    var db = e.target.result, tx = db.transaction(store, 'readwrite');
                    tx.objectStore(store).put(value, key);
                    tx.oncomplete = function() { callback(); };
                    tx.onerror    = function() { callback(); };
                };
                req.onerror = function() { callback(); };
             },
        'com.metaldetectoraudioapp.web.storage.idbPutBytesFromGlobal' : (store, key, count, callback) => { 
                var src = window.__ktWriteBuf;
                var arr = new Uint8Array(count);
                for (var i = 0; i < count; i++) arr[i] = src[i] & 0xFF;
                var req = indexedDB.open('metaldetector_dataset', 1);
                req.onupgradeneeded = function(e) {
                    var db = e.target.result;
                    ['meta','audio','images'].forEach(function(s) {
                        if (!db.objectStoreNames.contains(s)) db.createObjectStore(s);
                    });
                };
                req.onsuccess = function(e) {
                    var db = e.target.result, tx = db.transaction(store, 'readwrite');
                    tx.objectStore(store).put(arr.buffer, key);
                    tx.oncomplete = function() { callback(); };
                    tx.onerror    = function() { callback(); };
                };
                req.onerror = function() { callback(); };
             },
        'com.metaldetectoraudioapp.web.storage.idbGetBytesToGlobal' : (store, key, notFound, found) => { 
                var req = indexedDB.open('metaldetector_dataset', 1);
                req.onupgradeneeded = function(e) {
                    var db = e.target.result;
                    ['meta','audio','images'].forEach(function(s) {
                        if (!db.objectStoreNames.contains(s)) db.createObjectStore(s);
                    });
                };
                req.onsuccess = function(e) {
                    var db = e.target.result, tx = db.transaction(store, 'readonly');
                    var r = tx.objectStore(store).get(key);
                    r.onsuccess = function() {
                        if (r.result === undefined || r.result === null) { notFound(); return; }
                        var view = new Int8Array(r.result);
                        window.__idbTmpBytes = view;
                        found(view.length);
                    };
                    r.onerror = function() { notFound(); };
                };
                req.onerror = function() { notFound(); };
             },
        'com.metaldetectoraudioapp.web.storage.idbDelete' : (store, key, callback) => { 
                var req = indexedDB.open('metaldetector_dataset', 1);
                req.onsuccess = function(e) {
                    var db = e.target.result, tx = db.transaction(store, 'readwrite');
                    tx.objectStore(store).delete(key);
                    tx.oncomplete = function() { callback(); };
                    tx.onerror    = function() { callback(); };
                };
                req.onerror = function() { callback(); };
             },
        'com.metaldetectoraudioapp.web.ui.screen.formatCoordinate' : (value) => value.toFixed(6),
        'com.metaldetectoraudioapp.web.ui.screen.formatReviewCoordinate' : (value) => value.toFixed(6),
        'com.metaldetectoraudioapp.web.viewmodel.readRecBufAt' : (i) => window.__recBuf[i],
        'com.metaldetectoraudioapp.web.viewmodel.buildRecCaptureGraph' : (onChunk) => { 
                var stream = window.__recStream;
                var ctx = new (window.AudioContext || window.webkitAudioContext)();
                window.__recCtx = ctx;
                // iOS Safari starts the context suspended; resume it within this user gesture.
                if (ctx.state === 'suspended' && ctx.resume) ctx.resume();
                var src = ctx.createMediaStreamSource(stream);
        
                function sendChunk(channelData) {
                    window.__recBuf = channelData;
                    onChunk(Math.round(ctx.sampleRate), channelData.length);
                }
        
                if (ctx.audioWorklet) {
                    ctx.audioWorklet.addModule('/app/mic-worklet.js').then(function() {
                        var node = new AudioWorkletNode(ctx, 'mic-processor');
                        var silentGain = ctx.createGain();
                        silentGain.gain.value = 0;
                        window.__recNode = node;
                        window.__recSilentGain = silentGain;
                        node.port.onmessage = function(e) { sendChunk(e.data); };
                        src.connect(node);
                        node.connect(silentGain);
                        silentGain.connect(ctx.destination);
                    }).catch(function() { workletFallback(ctx, src, sendChunk); });
                } else { workletFallback(ctx, src, sendChunk); }
        
                function workletFallback(ctx, src, sendChunk) {
                    var proc = ctx.createScriptProcessor(4096, 1, 1);
                    window.__recProc = proc;
                    proc.onaudioprocess = function(e) { sendChunk(e.inputBuffer.getChannelData(0)); };
                    src.connect(proc);
                    proc.connect(ctx.destination);
                }
             },
        'com.metaldetectoraudioapp.web.viewmodel.stopWebCapture' : () => { 
                if (window.__recNode)   { window.__recNode.disconnect();   window.__recNode = null; }
                if (window.__recSilentGain) { window.__recSilentGain.disconnect(); window.__recSilentGain = null; }
                if (window.__recProc)   { window.__recProc.disconnect();   window.__recProc = null; }
                if (window.__recStream) { window.__recStream.getTracks().forEach(function(t) { t.stop(); }); window.__recStream = null; }
                if (window.__recCtx)    { window.__recCtx.close();         window.__recCtx = null; }
                window.__recBuf = null;
             }
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }

    const wasmFilePath = './OnDeviceAudioApp-webApp.wasm';

    const importObject = {
        js_code,
        intrinsics: {
            tag: wasmTag
        },
        './skiko.mjs': imports['./skiko.mjs'],

    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject);
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./OnDeviceAudioApp-webApp.wasm',import.meta.url).href), importObject)).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
